import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import './DialogScene.scss'
import { soundToPlay } from '../../../mechanics/sounds/sound';
import { campSlice } from '../../../store/reducers/campReducer';
import ImgWithFallback from '../../ui/ImgWithFallback';

const DialogScene = () => {
    const dispath = useAppDispatch()
    const { setScene } = sceneSlice.actions
    const { setAllies } = campSlice.actions
    const locations = useAppSelector(state => state.SceneReducer.locations)
    const alliesArr = useAppSelector(state => state.campReducer.allies)
    const locationsIndex = useAppSelector(state => state.SceneReducer.currentLocation)
    const [currentAlly] = useState(locations.getLocationsSet()[locationsIndex].getAlly())

    useEffect(() => {
        soundToPlay("greeting")
    })

    const nextLocation = () => {
        dispath(setScene("explore"))
    }

    function getAlly() {
        currentAlly.setIsFound(true)
        dispath(setAllies([...alliesArr, currentAlly]))
        nextLocation()
    }

    const dialogText = currentAlly.getIsFound() ?
        (<p className="dialog__body-text">Hello, how you doing?</p>) :
        (<p className="dialog__body-text">Hello stranger, It's too dangerous to go alone. I can help.</p>)

    return (
        <div className='dialog-scene'>
            <div className="dialog-scene__bimg">
                <ImgWithFallback
                    src={locations.getLocationsSet()[locationsIndex].getBackground().webp}
                    fallbackSrc={locations.getLocationsSet()[locationsIndex].getBackground().img} />
            </div>
            <div className="dialog-scene__wrapper">
                <div className="dialog-scene__content">
                    <div className="dialog-scene__content-npc">
                        <ImgWithFallback
                            src={currentAlly.getImg().webp}
                            fallbackSrc={currentAlly.getImg().img} />
                    </div>
                    <div className="dialog-scene__content-dialog dialog__body">
                        <h2 className="dialog__body-npc-name">{currentAlly.getName()} / <span>{currentAlly.getProfession()}</span></h2>
                        {dialogText}
                        {!currentAlly.getIsFound() && <p className="dialog__body-text answer" onClick={getAlly}>Add ally</p>}
                        <p className="dialog__body-text answer" onClick={nextLocation}>Leave</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DialogScene;